import React from 'react';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export default function NotFound(): ReactElement {
	const { t } = useTranslation();
	return (
		<div className='flex h-screen w-screen flex-col items-center justify-center font-semibold'>
			<p className='text-2xl'>404</p>
			<p className='text-gray text-xl'>{t('common.page_not_found')}</p>
		</div>
	);
}
